import React from 'react';

export const Default = () => (
    <div>
        <p/>
        <h2>The page you are trying to access doesn't exit on Ancient Cedars</h2>
    </div>
)
